import { Component, EventEmitter, Output } from '@angular/core';
import { COMMON_MODULES } from '@src/app/core/constants';
declare var $: any;
@Component({
  selector: 'app-membership-modal',
  standalone: true,
  imports: [...COMMON_MODULES],
  templateUrl: './membership-modal.component.html',
  styleUrl: './membership-modal.component.scss'
})
export class MembershipModalComponent {

  preference = 'Individual';
  noOfChildren = 0;
  planType = 'Individual';
  childErr = false;

  @Output('onModalClose') modalClose: any = new EventEmitter();

  open() {
    $('#exampleModal').modal('show');
  }

  setPreference(value: any, planType: any) {
     this.preference = value;
     this.planType = planType;
  }

  // closeModal() {
  //   this.modalClose.emit({preference: this.preference, childCount: this.noOfChildren});
  // }

  saveAndClose() {
    
    if ((this.preference == 'Individual + Family' || this.preference == 'Individual + Children') && this.noOfChildren == 0) {
       this.childErr = true;
       return;
    } else {
      this.childErr = false;
    }

    this.modalClose.emit({preference: this.preference, childCount: this.noOfChildren, planType: this.planType});
    $('#exampleModal').modal('hide');
  }

  increaseCount() {
    if (this.noOfChildren != 8) {
      this.noOfChildren += 1;
    }
  }

  decreaseCount() {
    if (this.noOfChildren != 0) {
      this.noOfChildren -= 1;
    }
  }
}
